"use strict";
import { CN_API_ROOT, CN_HOST } from "@/configs";
import { RESET_USER, SET_USER } from "@/store/mutation-types";
import Vue from "vue";

const DEFAULT_USER = {
  cn_number: "",
  first_name: "",
  last_name: "",
  email: "",
  password: "",
  signup_site_brand_pin_code: "",
  profile: {
    country_id: "",
    major_interests: [],
  },
  agree_terms: false,
  labels: [],
};
const state = Object.assign({}, DEFAULT_USER);

const mutations = {
  [SET_USER](state, payload) {
    state.cn_number = payload.cn_number ?? state.cn_number;
    state.first_name = payload.first_name ?? state.first_name;
    state.last_name = payload.last_name ?? state.last_name;
    state.email = payload.email ?? state.email;
    state.password = payload.password ?? state.password;
    state.profile = payload.profile ?? state.profile;
    state.signup_site_brand_pin_code =
      payload.signup_site_brand_pin_code ?? state.signup_site_brand_pin_code;
    state.agree_terms = payload.agree_terms ?? state.agree_terms;
    state.labels = payload.labels ?? state.labels;
  },
  [RESET_USER](state) {
    state = Object.assign({}, DEFAULT_USER);
  },
};

// context = {
//     state,      // `store.state`，
//     rootState,  // `store.state`，
//     commit,     // `store.commit`
//     dispatch,   // `store.dispatch`
//     getters,    // `store.getters`
//     rootGetters // `store.getters`
// }
const actions = {
  login(context, payload) {
    const { username, password } = payload;
    return new Promise((resolve, reject) => {
      Vue.http
        .get("auth", {
          headers: {
            username: username,
            password: password,
          },
          params: {
            action: "login",
          },
        })
        .then((res) => {
          let token = res?.data?.data?.token;
          if (token) {
            resolve({
              token: token,
              path: `${CN_HOST}/site/token/${token}/redirect_to`,
            });
            return;
          }
          reject(res);
        })
        .catch(reject);
    });
  },
  createUser(context, payload) {
    const { commit, rootState, state } = context;
    return new Promise((resolve, reject) => {
      Vue.http
        .post(`${CN_API_ROOT}/user`, state, {
          params: {
            signup_site_brand: rootState?.siteBrand?.brand,
            request_temp_auth: 1,
          },
        })
        .then((ctx) => {
          const { data } = ctx;
          if (data?.result) {
            commit(SET_USER, { cn_number: data?.data?.cn_number });
          }
          resolve(data);
        })
        .catch(reject);
    });
  },
};

// state,       // all state
// getters,     // store.getters
// rootState    // store.state
// rootGetters  // getters
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
